import { sumCreditLineAmounts } from '../../promotion-credit/sum-credit-line-amounts.js';
import { PROMOTION_CREDIT_CONSTRAINTS } from './constraints.js';
/** Rejects a category repeated across lines and an amount that differs from the lines' sum. */
export function refineCreditLines(value, context) {
    const lines = value.lines;
    if (!lines || lines.length === 0)
        return;
    const seenIds = new Set();
    const seenCategories = new Set();
    lines.forEach((line, index) => {
        // Two rows for one stored line would apply in sequence and leave the amount disagreeing with the lines.
        if (line.id) {
            if (seenIds.has(line.id)) {
                context.addIssue({
                    code: 'custom',
                    message: 'Each line can be sent only once.',
                    path: ['lines', index, 'id'],
                });
            }
            seenIds.add(line.id);
        }
        if (seenCategories.has(line.productTreeId)) {
            context.addIssue({
                code: 'custom',
                message: 'Each category can appear on only one line.',
                path: ['lines', index, 'productTreeId'],
            });
        }
        seenCategories.add(line.productTreeId);
    });
    const sum = sumCreditLineAmounts(lines);
    // Checked before the client's amount, so a zero-sum set of lines reports once instead of as an amount mismatch too.
    if (!sum.greaterThan(0)) {
        context.addIssue({
            code: 'custom',
            message: 'The credit lines must add up to more than 0.',
            path: ['lines'],
        });
        return;
    }
    const { max } = PROMOTION_CREDIT_CONSTRAINTS.amount;
    // An edit may send lines without an amount, so the cap on the amount alone would never see their sum.
    if (sum.greaterThan(max)) {
        context.addIssue({
            code: 'custom',
            message: `The credit lines must add up to ${max.toLocaleString('en-US')} or less.`,
            path: ['lines'],
        });
        return;
    }
    if (value.amount == null)
        return;
    if (!sum.equals(value.amount)) {
        context.addIssue({
            code: 'custom',
            message: `Amount must equal the sum of the credit lines (${sum.toFixed(2)}).`,
            path: ['amount'],
        });
    }
}
//# sourceMappingURL=refine-credit-lines.js.map